var exports = {
  "pq": "x61f99309--bce2d5--info",
  "UU": "x61f99309--bce2d5--name",
  "nf": "x61f99309--bce2d5--link",
  "Ej": "x61f99309--bce2d5--size",
};

module.exports = exports;
